import TablaConciliacion from "../../../TablaConciliacion";

function TablaPacificoTres() {
  return <TablaConciliacion nombreUseCase="pacificotres" titulo="PACIFICO TRES" />;
}

export default TablaPacificoTres;
